/**
 * Imported first by every page: the game data takes the chosen language before any module
 * reads a name, and the page's static text is translated as soon as it exists.
 */
import { localizeData } from "./data";
import { lang, watchDom } from "./index";

localizeData();
document.documentElement.lang = lang();
if (document.readyState === "loading")
  document.addEventListener("DOMContentLoaded", () => watchDom(), { once: true });
else watchDom();
